<template>
  <div
    class="intent-item pa-0 mb-3"
    :style="{
      border: `1px solid ${$vuetify.theme.primary}`,
      'border-left': intentStatus.isOnline ? `5px solid #a0e83d` : `5px solid red`
    }"
    :class="{ edit: isEdit }"
    v-if="intent"
  >
    <v-layout wrap v-if="!isEdit" @click="toggleDetail">
      <v-flex xs12 sm8>
        <div v-if="!isEdit" class="text-truncate pa-2">
          {{ intentLabel(intent.intentname) }}
        </div>
      </v-flex>

      <v-flex xs12 sm4 class="text-xs-right pa-1">
        <div style="display: inline-block" @click.stop>
          <template v-if="isCommentToInbox && !isLiveStream">
            <v-chip
              label
              outline
              small
              disabled
              color="info"
              v-if="postidlist.includes.length == 0 && postidlist.excludes.length == 0"
            >
              {{ $t('Replying all post(s)') }}
            </v-chip>
            <v-chip
              label
              outline
              small
              disabled
              color="info"
              v-else-if="postidlist.includes.length > 0"
              >{{ $t('Post(s) will be replied') }} ({{ postidlist.includes.length }})</v-chip
            >
            <v-chip
              label
              outline
              small
              disabled
              color="info"
              v-else-if="postidlist.excludes.length > 0"
              >{{ $t("Post(s) won't be replied") }} ({{ postidlist.excludes.length }})</v-chip
            >

            <div class="clearfix" style="margin-bottom: 10px"></div>
          </template>
          <template
            v-if="selectedBot.theme == 'universalutilities' && $route.name != 'allinonechat'"
          >
            <template
              v-if="intent.intentgroup == selectedBot.uu_areaname || !selectedBot.uu_areaname"
            >
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="!isEdit"
                @click="isEdit = true"
              >
                <em class="fas fa-pencil-alt" />
              </v-btn>
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="
                  !isEdit &&
                  intent.intentname != '{default}' &&
                  intent.intentname != '{default_comment_to_inbox}'
                "
                @click="onCopyMyIntent()"
              >
                <em class="fa fa-copy middle" />
              </v-btn>
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="
                  !isEdit &&
                  intent.intentname != '{default}' &&
                  intent.intentname != '{default_comment_to_inbox}'
                "
                @click="$emit('onDelete')"
              >
                <em class="fa fa-trash middle" />
              </v-btn>
            </template>
          </template>
          <template v-else-if="$route.name != 'allinonechat'">
            <template
              v-if="
                ['{default_comment_to_inbox}'].includes(intent.intentname) &&
                $store.getters.getPackage != 'premium' &&
                selectedBot.pagetype != 'enterprise'
              "
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="extra-small ma-1" readonly fab outline small color="grey" v-on="on">
                    <v-icon>lock</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Upgrade to Premium Plan') }}</span>
              </v-tooltip>
            </template>
            <template v-else>
              <v-btn fab outline color="primary" class="extra-small ma-1" @click="$emit('onEdit')">
                <em class="fas fa-pencil-alt" />
              </v-btn>
            </template>
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              v-if="
                !isEdit &&
                intent.intentname != '{default}' &&
                !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname)
              "
              @click="$emit('onDelete')"
            >
              <em class="fa fa-trash middle" />
            </v-btn>
          </template>
          <template v-else>
            <v-btn depressed color="primary" @click="sendToLivechat">{{ $t('Send') }}</v-btn>
          </template>
        </div>
      </v-flex>

      <v-flex xs10 class="pa-1">
        <v-chip
          small
          color="#00c300"
          text-color="white"
          v-if="
            $store.state.linenotifylist.length > 0 &&
            ((intent.linenoti_status && selectedBot.notify_intent && !isCommentToInbox) ||
              (intent.linenoti_status && selectedBot.notify_comment && isCommentToInbox))
          "
          disabled
        >
          <v-avatar>
            <em class="fas fa-bell" />
          </v-avatar>
          {{ $t('Line Notify') }}
        </v-chip>

        <v-chip
          small
          :color="intentStatus.isStarttime ? '#a0e83d' : 'red'"
          text-color="white"
          v-if="intent.starttime"
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          <template v-if="intent.starttime">
            Start
            <template v-if="intent.onlytime">{{ intent.starttime | DateFormat('HH:mm') }}</template>
            <template v-else>{{ intent.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
          </template>
        </v-chip>
        <v-chip
          small
          :color="intentStatus.isEndtime ? '#a0e83d' : 'red'"
          text-color="white"
          v-if="intent.endtime"
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          <template v-if="intent.endtime">
            End
            <template v-if="intent.onlytime">{{ intent.endtime | DateFormat('HH:mm') }}</template>
            <template v-else>{{ intent.endtime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
          </template>
        </v-chip>
      </v-flex>
      <v-flex xs2 class="text-xs-right pa-1">
        <template v-if="!isEdit">
          <div @click="showDetail = !showDetail">
            <span
              class="fas"
              :style="`font-size: 1.5em;margin-right: 5px; cursor: pointer; color: ${$vuetify.theme.primary}`"
              :class="{ 'fa-chevron-down': !showDetail, 'fa-chevron-up': showDetail }"
            ></span>
          </div>
        </template>
      </v-flex>
    </v-layout>

    <div>
      <template v-if="showDetail">
        <v-divider></v-divider>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <template v-if="answers">
              <div class="answer pa-2">
                <template v-if="isCommentToInbox">
                  <p>{{ $t('Chatbot Question') }}</p>

                  <template v-if="answers && answers[0].length > 0">
                    <message-viewer v-model="answers"></message-viewer>
                  </template>
                  <p v-else class="primary-color">{{ $t('No reply') }}</p>
                </template>
                <template v-else>
                  <p>{{ $t('Chatbot Question') }}</p>
                  <template v-if="intent.a_type == 'json'">
                    <div>
                      <div>
                        <template v-if="answers && answers.length > 0 && answers[0].length > 0">
                          <message-viewer v-model="answers"></message-viewer>
                        </template>
                        <p v-else class="primary-color">{{ $t('No reply') }}</p>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="intent.a_type == 'text'">
                    <div style="overflow-x: auto">
                      <div>
                        <div
                          v-for="(answer, index) in answers"
                          :key="'answer_' + index"
                          style="margin-bottom: 5px; flex-grow: 1; padding: 0px 10px"
                          :style="{ 'border-right': answers.length > 1 ? '1px dashed #eee' : '' }"
                        >
                          <div v-for="(message, mindex) in answer" :key="'message_' + mindex">
                            <template v-if="message.type == 'text'">
                              <div
                                class="message"
                                style="
                                  float: left;
                                  position: relative;
                                  border-radius: 12px;
                                  max-width: 181px;
                                  overflow-wrap: break-word;
                                  min-height: 22px;
                                  min-width: 14px;
                                  line-height: 15.36px;
                                  overflow: hidden;
                                  margin-bottom: 5px;
                                "
                              >
                                <div style="font-size: 12px; color: black">
                                  <div style="padding: 5px 8px 6px; background-color: #f1f0f0">
                                    <span style="line-height: 15.36px">
                                      <specialtext :text="message.value.text"></specialtext>
                                    </span>
                                  </div>
                                </div>
                                <div class="clearfix"></div>
                                <div
                                  v-if="message.value.buttons.length > 0"
                                  style="
                                    float: left;
                                    width: 100%;
                                    border: 1px solid #eee;
                                    border-bottom-left-radius: 12px;
                                    border-bottom-right-radius: 12px;
                                    overflow: hidden;
                                  "
                                >
                                  <ul
                                    class="list-group list-group-flush"
                                    style="margin-bottom: 0px"
                                  >
                                    <li
                                      class="list-group-item"
                                      style="
                                        border: none;
                                        border-top: 1px solid #eee;
                                        border-radius: 0px;
                                        text-align: center;
                                        padding: 2px 15px;
                                      "
                                      v-for="(button, bindex) in message.value.buttons"
                                      :key="bindex"
                                      :style="{
                                        'border-top': bindex != 0 ? '1px solid #eee' : 'none'
                                      }"
                                    >
                                      <span style="color: #0084ff">{{ button.title }}</span>
                                      <p style="margin: 0; font-size: 10px">
                                        <template v-if="button.type == 'web_url'">
                                          {{ button.url }}
                                        </template>
                                        <template v-if="button.type == 'postback'">
                                          {{ button.payload }}
                                        </template>
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="message.type == 'image'">
                              <div
                                class="message"
                                style="
                                  float: left;
                                  position: relative;
                                  border-radius: 12px;
                                  width: 181px;
                                  overflow-wrap: break-word;
                                  min-height: 22px;
                                  min-width: 14px;
                                  line-height: 15.36px;
                                  overflow: hidden;
                                  margin-bottom: 5px;
                                "
                              >
                                <div style="font-size: 12px; color: black">
                                  <img :src="message.value" alt style="width: 100%" />
                                </div>
                              </div>
                            </template>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="intent.a_type == 'template'">
                    <generic-viewer v-model="answers"></generic-viewer>
                  </template>
                  <template v-else-if="intent.a_type == 'message' || intent.a_type == 'generic'">
                    <intent-getstarted v-model="welcomemessage"></intent-getstarted>
                  </template>
                  <template v-else-if="intent.a_type == 'viewsummary'">
                    <view-cart-summary-viewer></view-cart-summary-viewer>
                  </template>
                  <template v-else-if="intent.a_type == 'none'">{{ $t('No reply') }}</template>
                </template>
              </div>
            </template>
          </v-flex>
          <v-flex xs12 sm6>
            <template v-if="answers">
              <div class="answer pa-2">
                <template v-if="answers[0].length > 0">
                  <div v-if="!isCommentToInbox">
                    <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                    <div class="quickreply">
                      <template v-if="replies.length > 0">
                        <ul class="tags">
                          <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
                            {{ reply }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>-</template>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="question pa-2">
              <template v-if="intent.intentname == '{default}'"></template>
              <template
                v-else-if="
                  ['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname)
                "
              ></template>
              <template v-else>
                <p>{{ $t('customer says') }}</p>
                <template v-if="normal && normal.length > 0">
                  <label class="caption">{{ $t('Keyword') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <!-- :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`" -->
                    <li
                      class="tag"
                      :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`"
                      v-for="(question, index) in normal"
                      :key="'normal_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="keyword && keyword.length > 0">
                  <label class="caption">{{ $t('Keyword') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`"
                      v-for="(question, index) in keyword"
                      :key="'keyword_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="exactly && exactly.length > 0">
                  <label class="caption">{{ $t('Exact word') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in exactly"
                      :key="'exactly_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="startwith && startwith.length > 0 && $store.getters.getPackage == 'premium'"
                >
                  <label class="caption">{{ $t('Start with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in startwith"
                      :key="'startwith_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="endwith && endwith.length > 0 && $store.getters.getPackage == 'premium'"
                >
                  <label class="caption">{{ $t('End with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in endwith"
                      :key="'endwith_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="
                    startandendwith &&
                    startandendwith.length > 0 &&
                    $store.getters.getPackage == 'premium'
                  "
                >
                  <label class="caption">{{ $t('Start and End with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in startandendwith"
                      :key="'startandendwith_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>

                <label v-show="isOtherLang && $store.getters.getPackage != 'premium'">
                  <em class="fas fa-exclamation-circle" />
                  {{
                    $t(
                      'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
                    )
                  }}
                </label>
              </template>
            </div>
          </v-flex>
        </v-layout>
        <div
          v-if="
            intent.userstatus ||
            (intent.linenoti_status && intent.linenoti_text && intent.linenoti_text.trim() != '') ||
            (intent.context_in && !['comment', 'facebooklive'].includes(intent.context_in)) ||
            intent.context_out ||
            (usertags && usertags.length > 0)
          "
        >
          <v-divider></v-divider>

          <v-tabs v-model="advancedTab" slider-color="primary" touchless>
            <v-tab :key="0" ripple>{{ $t('Customer') }}</v-tab>
            <v-tab :key="1" ripple v-show="!isCommentToInbox">{{ $t('Context') }}</v-tab>
            <v-tab :key="2" ripple>{{ $t('Line Notify') }}</v-tab>

            <v-tab
              :key="4"
              ripple
              v-if="
                selectedBot.theme == 'ticket' ||
                $store.state.ticketPageid.includes(selectedBot.pageid)
              "
              >{{ $t('Intent Group') }}</v-tab
            >

            <v-tab-item :key="0">
              <v-card flat>
                <v-card-text>
                  <div>
                    <div class="caption">{{ $t('Status') }}</div>
                    <p class="primary-color">{{ intent.userstatus ? intent.userstatus : '-' }}</p>
                  </div>
                  <div>
                    <div class="caption">{{ $t('Tag') }}</div>
                    <ul class="tags pt-1">
                      <li
                        class="tag"
                        v-for="(usertag, index) in usertags"
                        :key="'usertag_' + index"
                      >
                        <specialtext :text="usertag"></specialtext>
                      </li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="1" v-if="!isCommentToInbox">
              <v-card flat>
                <v-card-text>
                  <v-layout>
                    <template v-if="!['comment', 'facebooklive'].includes(intent.context_in)">
                      <v-flex>
                        <div class="caption">Context In</div>
                        <p class="primary-color">
                          {{ intent.context_in ? intent.context_in : '-' }}
                        </p>
                      </v-flex>
                    </template>
                    <template>
                      <v-flex>
                        <div class="caption">Context Out</div>
                        <p class="primary-color">
                          {{ intent.context_out ? intent.context_out : '-' }}
                        </p>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-card flat>
                <v-card-text>
                  <template>
                    <div class="caption">{{ $t('Line Notify') }}</div>
                    <div class="primary-color">
                      {{ intent.linenoti_text ? intent.linenoti_text : '-' }}
                    </div>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="4">
              <v-card flat>
                <v-card-text>
                  <v-layout
                    v-if="
                      selectedBot.theme == 'ticket' ||
                      $store.state.ticketPageid.includes(selectedBot.pageid)
                    "
                    row
                    wrap
                  >
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Group') }}</div>
                        <p class="primary-color">
                          {{
                            intentgroup.assigngroupid &&
                            agentGroup.find((el) => el.id == intentgroup.assigngroupid)
                              ? agentGroup.find((el) => el.id == intentgroup.assigngroupid)
                                  .groupname
                              : '-'
                          }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Sub Group') }}</div>
                        <p class="primary-color">
                          {{
                            intentgroup.assignsubgroupid &&
                            agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid)
                              ? agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid)
                                  .subgroupname
                              : '-'
                          }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Priority') }}</div>
                        <p class="primary-color">
                          {{ intentgroup.priority ? intentgroup.priority : '-' }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Due Date') }}</div>
                        <p class="primary-color">
                          {{ intentgroup.duedate ? intentgroup.duedate : '-' }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Tags') }}</div>
                        <p class="primary-color">
                          {{ intentgroup.tags ? intentgroup.tags : '-' }}
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                  <div v-else>
                    <div class="caption">{{ $t('Intent Group') }}</div>
                    <p class="primary-color">{{ intentgroup }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import manageIntent from '@/components/view/intent/intent-manage'
import specialtext from '@/components/elements/specialtext'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import ModalDialog from '@/components/elements/ModalDialog'
import FacebookScreen from '@/components/elements/FacebookScreen'
import api from '@/api'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['value', 'excludedIntentName', 'isCommentToInbox', 'filterIntents', 'isLiveStream'],
  data: function () {
    return {
      isEdit: false,
      intent: this.value,
      showDetail: false,
      showPreview: false,
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],
      isOtherLang: false,
      advancedTab: null
    }
  },
  mounted: function () {
    if (this.intent) {
      // this.showDetail = this.intent.isShow
      this.formatData(this.intent.q_val)
    }
  },
  components: {
    'manage-intent': manageIntent,
    specialtext,
    IntentGetstarted,
    GenericViewer,
    ModalDialog,
    FacebookScreen,
    MessageViewer,
    ViewCartSummaryViewer,
    ToggleButton
  },
  computed: {
    intentgroup() {
      if (this.intent.intentgroup) {
        if (
          this.selectedBot.theme == 'ticket' ||
          this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
        ) {
          try {
            return JSON.parse(this.intent.intentgroup)
          } catch (error) {
            return this.intent.intentgroup
            console.log(error)
          }
        } else {
          return this.intent.intentgroup
        }
      } else {
        return '-'
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),
    intentStatus() {
      let vm = this
      let starttime = vm.intent.starttime
        ? vm.intent.onlytime
          ? moment().format('YYYY-MM-DD') + ' ' + moment(vm.intent.starttime).format('HH:mm')
          : vm.intent.starttime
        : null
      let endtime = vm.intent.endtime
        ? vm.intent.onlytime
          ? moment().format('YYYY-MM-DD') + ' ' + moment(vm.intent.endtime).format('HH:mm')
          : vm.intent.endtime
        : null

      let isStarted = false
      let isEnded = false

      var isOnline = false
      var isStarttime = false
      var isEndtime = false

      if (endtime == null && starttime == null) {
        isOnline = this.intent.intentstatus
      } else if (starttime == null && moment() < moment(endtime)) {
        isOnline = this.intent.intentstatus
        isEndtime = true
      } else if (endtime == null && moment() > moment(starttime)) {
        isOnline = this.intent.intentstatus
        isStarttime = true
      } else if (moment(endtime) < moment(starttime)) {
        isOnline =
          this.intent.intentstatus && (moment() >= moment(starttime) || moment() <= moment(endtime))
        isStarttime = isEndtime = moment() >= moment(starttime) || moment() <= moment(endtime)
      } else {
        isOnline = this.intent.intentstatus && moment().isBetween(starttime, endtime)
        isStarttime = isEndtime = moment().isBetween(starttime, endtime)
      }

      // if (starttime == null && moment() < moment(endtime)) {
      //   isEndtime = true
      // }
      // if (endtime == null && moment() > moment(starttime)) {
      //   isStarttime = true
      // }
      // if(starttime == null )

      return {
        isOnline: isOnline,
        isStarttime: isStarttime,
        isEndtime: isEndtime
      }
    },
    questions: function () {
      if (this.intent.q_val !== '') {
        return this.intent.q_val.split(',')
      } else {
        return ''
      }
    },
    answers: function () {
      var vm = this
      if (vm.isCommentToInbox || vm.isLiveStream) {
        if (vm.isJsonParseable(vm.intent.a_val)) {
          return JSON.parse(vm.intent.a_val)
        } else {
          return [
            [
              {
                type: 'text',
                text: vm.intent.a_val
              }
            ]
          ]
        }
      } else if (vm.intent.a_val == '{welcome_message}') {
        return [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.intent.a_type == 'json') {
        return JSON.parse(vm.intent.a_val)
      } else if (vm.intent.a_val != '' && vm.intent.a_type == 'text') {
        var newGroup = []
        var group_messages = vm.intent.a_val.split('||')
        $.each(group_messages, function (index, group) {
          var messages = group.split('#nl')
          var newMessages = []
          $.each(messages, function (inedx, message) {
            if (vm.isURL(message)) {
              newMessages.push({
                type: 'image',
                value: message
              })
            } else if (!isNaN(message)) {
              newMessages.push({
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              })
            } else if (vm.isJsonParseable(message)) {
              newMessages.push({
                type: 'text',
                value: JSON.parse(message)
              })
            } else {
              newMessages.push({
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              })
            }
          })
          newGroup.push(newMessages)
        })

        return newGroup
      } else if (vm.intent.a_type == 'template') {
        if (vm.isJsonParseable(vm.intent.a_val)) {
          return JSON.parse(vm.intent.a_val)
        } else {
          return []
        }
      } else if (vm.intent.a_type == 'message') {
        return [
          [
            {
              type: 'text',
              text: vm.intent.a_val
            }
          ]
        ]
      } else if (vm.intent.a_type == 'none') {
        return [[]]
      } else if (vm.intent.a_type == 'viewsummary') {
        return [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    },
    replies: function () {
      var vm = this
      if (vm.intent.quick_reply !== '' && vm.intent.quick_reply != null) {
        var replies = vm.intent.quick_reply.split(',')
        return replies
      } else {
        return []
      }
    },
    usertags: function () {
      var vm = this
      if (vm.intent.usertags !== '' && vm.intent.usertags != null) {
        var usertags = vm.intent.usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    postidlist: function () {
      var vm = this
      var includes = []
      var excludes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      return { includes: includes, excludes: excludes }
    }
  },
  methods: {
    onChangeIntentStatus: function () {
      let intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
      this.$set(this.intent, 'intentstatus', !intentstatus)
      let data = {
        ...this.intent
      }
      var vm = this
      vm.$store.dispatch('loading')
      api
        .editIntent(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }
          vm.$store.dispatch('loading')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    editIntent() {
      this.isEdit = true
    },
    sendToLivechat() {
      this.$emit('sendToLivechat', this.intent.a_val)
    },
    onSave: function (payload) {
      this.isEdit = false
    },
    onClose: function (payload) {
      this.isEdit = false
    },
    toggleDetail: function () {
      this.intent.isShow = !this.intent.isShow
    },
    onCopyMyIntent: function () {
      let vm = this
      let data = {
        ...vm.intent
      }
      data.pageid = vm.selectedBot.pageid
      data.intentname = vm.intent.intentname + '_' + moment().format('x')
      data.a_val = vm.intent.a_val.replace(/ /gim, ' ')

      this.$emit('onCopyIntent', {
        onCopy: function () {
          return new Promise(async (resolve, reject) => {
            var result = await vm.$swal.fire({
              title: vm.$t('Do you want to copy {name}?', {
                name: vm.intent.intentname.replace(/\<|\>/g, '')
              }),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
            if (result.value) {
              vm.$store.dispatch('loading')
              api.addIntent(data, function (error, response) {
                if (error) {
                  console.error(error)
                  vm.$store.dispatch('loading')
                  reject()
                }
                data.id = response.id
                resolve(data)
                vm.$store.dispatch('loading')
              })
            }
          })
        }
      })
    },
    formatData: function (text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      var isPremium = vm.$store.getters.getPackage === 'premium'
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function (question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({
              text: keyword.trim(),
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else {
            vm.normal.push({ text: question, checkLang: vm.isSupportLanguage(question, isPremium) })
            if (!vm.isSupportLanguage(question, isPremium)) {
              vm.isOtherLang = true
            }
          }
        })
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.intent = newVal
      // this.showDetail = newVal.isShow
    },
    'intent.q_val': function (newVal, oldVal) {
      this.formatData(this.intent.q_val)
    },
    'value.isShow': function (newVal) {
      // this.showDetail = newVal
    },
    intent: function (newVal) {
      this.$emit('onUpdate', newVal)
      // this.intent = Object.assign({},newVal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/tero/IntentItem.vue